<div class="card step-card flex flex-column">
  <form [formGroup]="defaultDeviceCatalogForm" *ngIf="defaultDeviceCatalogForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="defaultDeviceCatalogForm.get('name')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="version">{{'attribute.version' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="version" type="text" formControlName="version" class="w-full">
        </div>
        <app-validation-errors [control]="defaultDeviceCatalogForm.get('version')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
        <app-validation-errors [control]="defaultDeviceCatalogForm.get('description')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="category">{{'model.category' | transloco}} (*)</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.category' | transloco"
            [options]="defaultDeviceCategories"
            [filter]="true"
            styleClass="w-full"
            id="category"
            optionLabel="name"
            formControlName="defaultDeviceCategory"
          ></p-dropdown>
        </div>
        <app-validation-errors [control]="defaultDeviceCatalogForm.get('defaultDeviceCategory')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="assetRepresentation">{{'model.assetRepresentation' | transloco}} (*)</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.assetRepresentation' | transloco"
            [options]="defaultAssetRepresentations"
            [filter]="true"
            styleClass="w-full"
            id="assetRepresentation"
            optionLabel="name"
            formControlName="defaultAssetRepresentation"
          ></p-dropdown>
        </div>
        <app-validation-errors [control]="defaultDeviceCatalogForm.get('defaultAssetRepresentation')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="version">{{'attribute.active' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-checkbox
            id="active"
            formControlName="active"
            binary="true"
            class="w-full"
            [disabled]="mode === 'create'"
          ></p-checkbox>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.next' | transloco"
          [disabled]="!defaultDeviceCatalogForm?.valid"
          (click)="onNextStep()"
          pButton
          pRipple
          class="flex-1"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
